export const RoutePutMerchflows_merchflowId_ = "/merchflows/:merchflowId";

export interface PayloadPutMerchflows_merchflowId_ {
  name?: string;
  notes?: string;
  go_live_date?: string;
}

export interface ResponsePutMerchflows_merchflowId_ {
  name: string;
  go_live_date: string | null;
  updated_at: string;
}
